import { Link } from "react-router-dom";
import AnimeCard from "@/components/feature/AnimeCard";
import { getLatestAnime } from "@/utils/anime";

export default function LatestUpdates() {
  const latest = getLatestAnime(9);

  return (
    <section>
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2 className="font-heading font-extrabold text-foreground-950 text-2xl md:text-3xl flex items-center gap-2">
            <i className="ri-history-line text-primary-500"></i>
            最新更新
          </h2>
          <p className="mt-1.5 text-sm text-foreground-500">
            刚刚更新的精彩动漫，追新不迷路
          </p>
        </div>
        <Link
          to="/search"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          查看更多
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        {latest.map((anime) => (
          <AnimeCard key={anime.id} anime={anime} />
        ))}
      </div>
    </section>
  );
}